/*@ngInject*/
const RuleMediator = function (ruleRepository, ruleUtil, ruleModel, ruleConditionType) {

    this.typeToConditionTypes = {};

    this.findRuleById = function (id) {
        return ruleRepository.findRuleById(id);
    };

    this.updateRule = function (rule) {
        return ruleRepository.updateRule(rule);
    };

    this.deleteRule = function (id) {
        // prevent auto save
        ruleModel.setUnsavedChanges(id, false);
        return ruleRepository.deleteRule(id);
    };

    this.activateRule = function (id) {
        return ruleRepository.activateRule(id);
    };

    this.deactivateRule = function (id) {
        return ruleRepository.deactivateRule(id);
    };

    this.getRuleActions = function (ruleType) {
        return ruleRepository.getRuleActions(ruleType);
    };

    this.getConditionTypes = function () {
        return ruleRepository.getConditionTypes();
    };

    this.addCondition = function (ruleConditionGroup, conditionType) {
        var condition = _.cloneDeep(this.typeToConditionTypes[conditionType]);
        ruleConditionGroup.subconditions.push(condition);
    };

    this.addGroup = function (ruleConditionGroup) {
        var compositeCondition = this.createCompositeCondition();
        ruleConditionGroup.subconditions.push(compositeCondition);
    };

    this.deleteSubcondition = function (parentRuleCondition, subconditionToDelete) {
        _.remove(parentRuleCondition.subconditions, function (subcondition) {
            return subcondition === subconditionToDelete;
        });
    };

    this.deleteSubAction = function (parentRuleAction, actionToDelete) {
        _.remove(parentRuleAction, function (action) {
            return action === actionToDelete;
        });
    };

    this.addSubAction = function (ruleActionGroup, action) {
        ruleActionGroup.push(action);
    };

    this.createCompositeCondition = function () {
        var compositeCondition = _.cloneDeep(this.typeToConditionTypes[ruleConditionType.COMPOSITE]);
        return compositeCondition;
    };

    this.addAction = function (ruleAction) {

    };

    this.deleteAction = function (ruleAction) {

    };

    this.getOperators = function (type, isField) {
        return ruleRepository.getOperators(type, isField);
    };

    this.getSearchableValues = function (formTemplateUniqueName, fieldName) {
        return ruleRepository.getSearchableValues(formTemplateUniqueName, fieldName);
    };

    this.createConditionValue = function (valueType, typeName) {
        var value = {
            objectUri: '/' + valueType + '/',
            typeName: typeName
        };

        return value;
    };

    this.createFieldRule = function (fieldRules) {
        var ordinal,
            newFieldRule = {
                objectUri: '/Rule',
                name: 'New Rule'
            },
            compositeCondition = this.createCompositeCondition();

        newFieldRule.actions = [{
            createdBy: null,
            description: null,
            id: null,
            lastModifiedBy: null,
            name: null,
            objectUri: "/RawAction",
            rawExpression: "",
            timeCreated: null,
            timeLastModified: null,
            transformVariables: {},
            uri: 'com.firstbest.rules.model.RawAction:null'
        }];

        newFieldRule.condition = compositeCondition;

        ordinal = _.reduce(fieldRules, function (count, fieldRule) {
            if (_.startsWith(fieldRule.name, 'New Rule')) {
                return count + 1;
            } else {
                return count;
            }
        }, 1);

        newFieldRule.name += ' ' + ordinal;

        return newFieldRule;
    };

    this.convertToUnaryCondition = function (ruleConditionGroup, condition) {
        var unaryCondition = {
            operator: 'not',
            subcondition: condition,
            objectUri: '/UnaryCondition'
        };

        var conditionIndex = _.findIndex(ruleConditionGroup.subconditions, function (subcondition) {
            return subcondition === condition;
        });

        ruleConditionGroup.subconditions[conditionIndex] = unaryCondition;

        return unaryCondition;
    };

    this.convertFromUnaryCondition = function (ruleConditionGroup, condition) {
        var conditionIndex = _.findIndex(ruleConditionGroup.subconditions, function (subcondition) {
            return subcondition === condition;
        });

        ruleConditionGroup.subconditions[conditionIndex] = condition.subcondition;

        return condition.subcondition;
    };

    this.createVariableValueList = function (ruleConditionGroup) {
        var variableValueList = ruleUtil.createVariableValueList(ruleConditionGroup);
        ruleModel.setVariableValueList(variableValueList);
    };

    this.createRule = function (rule) {
        return ruleRepository.createRule(rule);
    };

    this.getMatchingTags = function (tagName) {
        return ruleRepository.getMatchingTags(tagName);
    };

    this.createTag = function (tag) {
        return ruleRepository.createTag(tag);
    };

    this.getTypeToConditionTypes = function () {
        var typeToConditionTypes = {};
        ruleRepository.getConditionTypes().then(function (result) {
            _.each(result, function (conditionType) {
                typeToConditionTypes[conditionType.name] = conditionType;
            }.bind(this));
        }.bind(this));

        this.typeToConditionTypes = typeToConditionTypes;
    };

    this.getTypeToConditionTypes();
};

angular.module('ums.configuration')
    .service('ruleMediator', RuleMediator);
